module.exports = __webpack_public_path__ + "static/img/new_logo_1.6349030e.png";